<template>

  <!-- TABLE -->
  <tr
  :class="{'selected': selected[item.id]}">
    <td class="sticky">

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      <v-layout align-center>
        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <v-avatar color="" size="36px" class="mr-2" style="background: linear-gradient(30deg, #EF9958, #DB4572);">
          <v-icon color="white">mdi-timeline-text-outline</v-icon>
        </v-avatar>
        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>
        <span 
        class=""
        v-html="highlightedID">
        </span>
      </v-layout>
    </td>
    <td>
      {{ item.category_name }}
    </td>
    <td>
      {{ item.item_count }}
    </td>
    <td>

    </td>
    <td>
      <div :class="['text-ellipsed']">
      {{ dateFromNow }}
      </div>
      <div class="label">
        {{ humanDate }}
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  props:['item', 'itemsMeta', 'searchTextID', 'selected'],
  data () {
    return {
      hover: false
    }
  },
  computed: {
    highlightedID () {
      var replacedStr = (this.searchTextID || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.id.toString().replace(new RegExp(replacedStr, 'gi'), '<span class="color1--text font-weight-bold">$&</span>')
      return '<span class="font-weight-regular">' + replacedStr + '</span>'
    },
    humanDate () {
      if (this.$moment.utc(this.item.date_created).isValid()) {
        return this.$moment(this.item.date_created).format('DD MMM YYYY, ddd')
      }
      return ''
    },
    dateFromNow () {
      if (this.$moment.utc(this.item.date_created).isValid()) {
        return this.$moment.utc(this.item.date_created).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">

</style>